<template>
	<div id="cortesia-page">
		<div class="floating-button" v-if="!isCargandoCortesia && !isCargandoEvento && Number(cortesia.CortesiaCntRestantes) > 0">
			<button @click.prevent="emitir()" v-if="!emitiendo">Emitir cortesía</button>
			<button disabled="disabled" v-else>Emitiendo <clip-loader class="emitiendo-loader" :color="'var(--color-darker)'" :size="'12px'"></clip-loader></button>
		</div>
		<div class="container" v-if="!isCargandoCortesia && !isCargandoEvento">
			<div class="cortesia-main">
				<div class="cortesia-main-top" v-if="Number(cortesia.CortesiaCntRestantes) > 0">
					<div class="cortesia-main-top-left">
						<span class="title">Cortesía</span>
						<p>Completa la información de los tickets que desees</p>
					</div>
				</div>
				<div class="cortesia-main-content" v-if="Number(cortesia.CortesiaCntRestantes) > 0">
					<div class="ticket" :id="'tn' + t.ticketNum" v-for="t in tickets" :key="t.ticketNum">
						<div class="ticket-top">
							<div class="ticket-top-left" v-if="tickets.length > 1">
								<span class="ticket-text">Ticket</span>
								<span class="ticket-id">{{ t.ticketNum }}</span>
							</div>
							<div class="ticket-top-right" :style="[tickets.length > 1 ? {'width': 'calc(100% - 74px)'} : {'width': '100%'}]">
								<span class="sector">Cortesía</span>
							</div>
						</div>
						<div class="ticket-row" :class="cortesia.CortesiaTribunaNombre.toUpperCase().trim() !== cortesia.CortesiaSectorDescripcion.toUpperCase().trim() ? 'row-multiple' : ''">
							<div class="input-group">
								<label v-if="evento.Escenario.EscenarioConfiguracionTribunaAlias.trim()">{{ evento.Escenario.EscenarioConfiguracionTribunaAlias.trim() }}</label>
								<label v-else>Acceso</label>
								<span class="tribuna-nombre">{{ cortesia.CortesiaTribunaNombre.trim() }}</span>
							</div>
							<div class="input-group" v-if="cortesia.CortesiaTribunaNombre.toUpperCase().trim() !== cortesia.CortesiaSectorDescripcion.toUpperCase().trim()">
								<label v-if="evento.Escenario.EscenarioConfiguracionSectorAlias.trim()">{{ evento.Escenario.EscenarioConfiguracionSectorAlias.trim() }}</label>
								<label v-else>Sector</label>
								<span class="tribuna-nombre">{{ cortesia.CortesiaSectorDescripcion.trim() }}</span>
							</div>
							<div class="input-group" v-if="t.ticketUbicacion !== null">
								<label>Fila</label>
								<span class="tribuna-nombre">{{ t.ticketUbicacion.filaNombre }}</span>
							</div>
							<div class="input-group" v-if="t.ticketUbicacion !== null">
								<label>Asiento</label>
								<span class="tribuna-nombre">{{ t.ticketUbicacion.asientoNombre }}</span>
							</div>
						</div>
						<div class="ticket-row-nominado" v-if="evento.Evento.EventoTicketNominado">
							<div class="ticket-row">
								<div class="input-group">
									<label :for="'nombre-' + t.ticketNum">Nombre</label>
									<input type="text" :name="'nombre-' + t.ticketNum" :id="'nombre-' + t.ticketNum" v-model="t.ticketNombre">
								</div>
							</div>
							<div class="ticket-row">
								<div class="input-group">
									<label :for="'apellido-' + t.ticketNum">Apellido</label>
									<input type="text" :name="'apellido-' + t.ticketNum" :id="'apellido-' + t.ticketNum" v-model="t.ticketApellido">
								</div>
							</div>
							<div class="ticket-row">
								<div class="input-group">
									<label :for="'documento-' + t.ticketNum">Documento</label>
									<div class="input-group-aux">
										<select :name="'tipodoc-' + t.ticketNum" :id="'tipodoc-' + t.ticketNum" v-model="t.ticketDocumentoTipo">
											<option :value="td.valor" v-for="td in tipoDocumentos" :key="td.valor">{{ td.descripcion }}</option>
										</select>
										<input type="text" :name="'documento-' + t.ticketNum" :id="'documento-' + t.ticketNum" v-model="t.ticketDocumento">
									</div>
								</div>
							</div>
						</div>
						<div class="ticket-row-campos" v-if="eventoCampos.length > 0">
							<div class="ticket-row" v-for="(campo, index) in eventoCampos" :key="campo.CampoCod">
								<div class="input-group" v-if="(campo.CampoTipo === 'O' && campo.Opciones.length > 0) || campo.CampoTipo !== 'O'">
									<label :for="'campo-' + campo.CampoCod">{{ campo.CampoDescripcion }}</label>

									<input type="text" :name="'campo-' + campo.CampoCod" :id="'campo-' + campo.CampoCod" v-model="t.Campos[index].TicketCampoValor" v-if="campo.CampoTipo === 'T'">
									<input type="text" :name="'campo-' + campo.CampoCod" :id="'campo-' + campo.CampoCod" v-model="t.Campos[index].TicketCampoValor" v-if="campo.CampoTipo === 'N'" @keypress="soloNumeros">
									<select :name="'campo-' + campo.CampoCod" :id="'campo-' + campo.CampoCod" v-model="t.Campos[index].TicketCampoValor" v-if="campo.CampoTipo === 'O'">
										<option :value="opcion.CampoOpcionId" v-for="opcion in campo.Opciones" :key="opcion.CampoOpcionId">{{ opcion.CampoOpcionValor }}</option>
									</select>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="cortesia-main-top" v-if="Number(cortesia.CortesiaCntIngresadas) > 0 && ticketsEmitidos.length > 0">
					<div class="cortesia-main-top-left">
						<span class="title">Cortesías ya emitidas</span>
					</div>
				</div>
				<div class="cortesia-main-content" v-if="Number(cortesia.CortesiaCntIngresadas) > 0 && ticketsEmitidos.length > 0">
					<div class="ticket-emitido" v-for="c in ticketsEmitidos" :key="c.TicketId">
						<span class="ticket-id">No. {{ c.TicketId }}</span>
						<div class="ticket-row" v-if="evento.Evento.EventoTicketNominado">
							<div class="field-group field-group-100">
								<label>Espectador</label>
								<span class="field">{{ c.PersonaNombre }} {{ c.PersonaApellido }}</span>
							</div>
						</div>
						<div class="ticket-row" v-if="evento.Evento.EventoTicketNominado">
							<div class="field-group field-group-100">
								<label>Documento</label>
								<span class="field">{{ c.PersonaDocumentoTipoNombre }} - {{ c.PersonaDocumento }}</span>
							</div>
						</div>
						<div class="ticket-bottom">
							<a :href="c.TicketURLS3" target="_blank" v-if="c.TicketGeneradoEnS3"><i class='bx bx-qr'></i>Ver ticket</a>
							<div class="ticket-generando" v-if="!c.TicketGeneradoEnS3">Generando ticket <clip-loader class="generando-loader" :color="'var(--color-darker)'" :size="'12px'"></clip-loader></div>
							<span class="disclaimer-generando" v-if="!c.TicketGeneradoEnS3">Estamos generando tu ticket. Aguarde unos segundos y podrás descargarlo.</span>
						</div>
					</div>
				</div>
			</div>
			<aside>
				<div class="aside-wrapper">
					<div class="aside-top" :style="{ 'background-image': 'url(' + evento.Evento.EventoFotoPrincipal + ')' }">
						<span class="evento-title">{{ evento.Evento.EventoNombre }}</span>
						<div class="aside-top-info">
							<img class="evento-foto" :src="evento.Evento.EventoFotoPrincipal" :alt="evento.Evento.EventoNombre">
							<div class="aside-top-info-right">
								<span class="evento-info-categoria">{{ evento.Categorias.EventoCategoriaNombre }}</span>
								<span class="evento-info-fecha">{{ evento.Fecha.EventoFechaHoraEscrita }}</span>
								<span class="evento-info-escenario">{{ evento.Escenario.EscenarioNombre }}</span>
							</div>
						</div>
					</div>
					<div class="aside-main">
						<div class="aside-row" v-if="Number(cortesia.CortesiaCntRestantes) > 0">
							<button @click.prevent="emitir()" v-if="!emitiendo">Emitir cortesía</button>
							<button disabled="disabled" v-else>Emitiendo <clip-loader class="emitiendo-loader" :color="'var(--color-darker)'" :size="'12px'"></clip-loader></button>
						</div>
					</div>
				</div>
			</aside>
		</div>
		<div class="container" v-else>
			<clip-loader class="evento-loader" :color="'var(--color-primary)'" :size="'52px'"></clip-loader>
		</div>
	</div>
</template>

<script>
	import axios from 'axios';
	import ClipLoader from 'vue-spinner/src/ClipLoader.vue'

	export default {
		data(){
			return{
				isCargandoCortesia: true,
				isCargandoEvento: true,
				eventoId: Number(this.$route.params.eventId),
				eventoSlug: this.$route.params.eventSlug,
				evento: null,
				eventoCampos: [],
				emitiendo: false,
				hayError: false,
				errorMsg: '',

				// Cortesia
				cortesia: null,
				tickets: [],
				ticketsEmitidos: [],
				tipoDocumentoCI: null,
				tipoDocumentos: [],
				cantidadIntentos: 0
			}
		},
		components: {
			ClipLoader
		},

		metaInfo: {
			title: 'Cortesía',
			titleTemplate: '%s 🎟 LineUp Tickets'
		},
		computed: {
			cantidadTicketsSinGenerar(){
				let cant = 0

				this.ticketsEmitidos.forEach((t) => {
					if(t.TicketGeneradoEnS3 === false){
						cant = cant + 1
					}
				});

				return cant
			}
		},
		watch: {
			ticketsEmitidos(newticketsActivos){
				this.ticketsEmitidos.forEach((t, index) => {
					if(t.TicketGeneradoEnS3 === false){
						this.timeoutCheckearTicket(t.TicketId, t.TicketURLS3Bucket, index);
					}
				});
			}
		},
		async mounted() {
			this.$store.dispatch('cargando', true);

			await this.tiposDocumentos();
			await this.getEvento();
			await this.getEventoCampos();
			await this.validarCortesia();

			this.$store.dispatch('cargando', false);
		},
		methods: {
			soloNumeros ($event) {
				let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
				if (keyCode < 48 || keyCode > 57) {
					$event.preventDefault();
				}
			},
			async tiposDocumentos(){
				try {
					let response = await axios.post('/WSDocumentoTipos', {});

					response.data.SDTDocumentoTipos.forEach((dt) => {
						this.tipoDocumentos.push({ valor: Number(dt.DocumentoTipoId), descripcion: dt.DocumentoTipoNombre });

						if(Number(dt.DocumentoTipoId) === 1){
							this.tipoDocumentoCI = { valor: Number(dt.DocumentoTipoId), descripcion: dt.DocumentoTipoNombre }
						}
					});
				} catch (error) {
					this.$router.push({ name: 'error' });
				}
			},
			async getEvento(){
				try {
					let response = await axios.post('/WSEvento', {
						EventoId: this.eventoId,
						EventoSlug: this.eventoSlug,
					});

					if(response.data.ErrorCod === 0){
						this.evento = response.data.SDTEvento
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
					this.$router.push({ name: 'error' });
				}
			},
			async getEventoCampos(){
				this.eventoCampos = []

				try {
					let response = await axios.post('/WSEventoCampos', {
						EventoId: this.eventoId
					});

					if(response.data.ErrorCod === 0){
						response.data.SDTEventoCampos.forEach((c) => {
							if(c.EventoCampoEnCortesia === true){
								this.eventoCampos.push(c)
							}
						})
					} else {
						this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoEvento = false
				}
			},
			async validarCortesia(){
				this.isCargandoCortesia = true;

				try {
					let response = await axios.post('/WSCortesiaValidar', {
						EventoId: this.eventoId,
						EventoSlug: this.eventoSlug,
						CortesiaId: Number(this.$route.params.cortesiaId),
						CortesiaToken: this.$route.params.cortesiaToken
					});

					if(response.data.ErrorCod === 0){
						this.cortesia = response.data.SDTCortesia;
						this.ticketsEmitidos = response.data.SDTTicketsCortesia;
						this.tickets = [];
						// this.eventoCampos = [];

						if(Number(this.cortesia.CortesiaCntRestantes) > 0){
							for(let i = 0; i<this.cortesia.CortesiaCntRestantes; i++){
								let sector = this.cortesia.CortesiaSectorDescripcion.replace('Sector ', '')

								let campos = []
								this.eventoCampos.forEach((c) => {
									campos.push({
										CampoCod: c.CampoCod,
										TicketCampoValor: null
									})
								})

								let ticket = {
									ticketNum: i + 1,
									ticketNombre: '',
									ticketApellido: '',
									ticketDocumentoTipo: Number(this.tipoDocumentoCI.valor),
									ticketDocumento: '',
									ticketTribuna: this.cortesia.CortesiaTribunaNombre,
									ticketSector: sector,
									ticketUbicacion: null,
									Campos: campos,
								}

								if(this.cortesia.Ubicacion.length > 0){
									for(let n=0; n<this.cortesia.Ubicacion.length; n++)	{
										if(n === i){
											let fila = this.cortesia.Ubicacion[n].CortesiaFilaNombre.replace('Fila ', '')
											let asiento = this.cortesia.Ubicacion[n].CortesiaAsientoNombre.replace('Asiento ', '')

											ticket.ticketUbicacion = { filaId: parseInt(this.cortesia.Ubicacion[n].CortesiaFilaId), filaNombre: fila, asientoId: parseInt(this.cortesia.Ubicacion[n].CortesiaAsientoId), asientoNombre: asiento }
										}
									}
								}

								this.tickets.push(ticket);
							}
						}

					} else {
						this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
						this.$router.push({ name: 'error' });
					}
				} catch (error) {
					this.$store.dispatch('showError', 'Ocurrió un error. Intenta nuevamente.')
					this.$router.push({ name: 'error' });
				} finally {
					this.isCargandoCortesia = false
				}
			},
			timeout(){
				return new Promise(resolve => setTimeout(resolve, 5000));
			},
			async timeoutCheckearTicket(ticketId, urlS3, index){
				do {
					await this.timeout();
					await this.checkearTicketGenerado(ticketId, urlS3);
				} while (this.ticketsEmitidos[index].TicketGeneradoEnS3 === false)
			},
			async checkearTicketGenerado(ticketId, urlS3){
				try {
					if(this.cantidadIntentos <= 5 * this.cantidadTicketsSinGenerar){
						let response = await fetch(urlS3);

						if(response.status === 200){
							let indexEmitidos = this.ticketsEmitidos.map(ticket => ticket.TicketId).indexOf(ticketId)
							this.ticketsEmitidos[indexEmitidos].TicketGeneradoEnS3 = true;

							this.cantidadIntentos = this.cantidadIntentos + 1
						} else {
							this.cantidadIntentos = this.cantidadIntentos + 1
							console.log('Ocurrió un error al checkear generación del PDF')
						}
					}
				} catch (error) {
					console.log('Ocurrió un error al checkear generacion del PDF')
				}
			},
			async emitir(){
				let colTicketCortesias = []
				let TicketCampoValor;
				let SDTTicketCampoValores = []
				let SDTTicketCampoValoresJSON = '';

				let todosVacios = true
				for(let v=0; v<this.tickets.length; v++){
					if(this.tickets[v].ticketApellido || this.tickets[v].ticketNombre || this.tickets[v].ticketDocumento){
						todosVacios = false
						break;
					}
				}

				let hayRepetidos = false

				if(todosVacios === true){
					this.$store.dispatch('showError', 'Debes ingresar al menos un ticket')
				} else {
					let hayError = false;

					for(let m=0; m<this.tickets.length; m++){
						if(this.tickets[m].ticketApellido || this.tickets[m].ticketNombre || this.tickets[m].ticketDocumento){
							if(this.tickets[m].ticketApellido && this.tickets[m].ticketNombre && this.tickets[m].ticketDocumento){
								for(let k=0; k<this.tickets.length; k++){
									if(k !== m){
										if(this.tickets[m].ticketDocumento && this.tickets[m].ticketDocumento === this.tickets[k].ticketDocumento){
											hayRepetidos = true;
											break;
										}
									}
								}

								if(hayRepetidos === true){
									hayError = true
									this.$store.dispatch('showError', 'Hay documentos repetidos')
									break;
								} else {
									// Validación de campos
									for(let k=0; k<this.eventoCampos.length; k++){
										let isCampoObligatorio = this.eventoCampos[k].EventoCampoObligatorio

										if(isCampoObligatorio){
											if(!this.tickets[m].Campos[k].TicketCampoValor && this.eventoCampos[k].CampoTipo === 'O'){
												hayError = true
												this.$store.dispatch('showError', 'Ticket ' + this.tickets[m].ticketNum + ': debes seleccionar ' + this.eventoCampos[k].CampoDescripcion.toLowerCase());
												break;
											}

											if(this.eventoCampos[k].CampoTipo !== 'O'){
												if(!this.tickets[m].Campos[k].TicketCampoValor){
													hayError = true
													this.$store.dispatch('showError', 'Ticket ' + this.tickets[m].ticketNum + ': debes ingresar ' + this.eventoCampos[k].CampoDescripcion.toLowerCase());
													break;
												} else {
													if(this.tickets[m].Campos[k].TicketCampoValor.trim() === ''){
														hayError = true
														this.$store.dispatch('showError', 'Ticket ' + this.tickets[m].ticketNum + ': debes ingresar ' + this.eventoCampos[k].CampoDescripcion.toLowerCase());
														break;
													}
												}
											}
										}
									}

									if(hayError === true){
										break;
									}

									let fil = null;
									let asi = null;

									if(this.tickets[m].ticketUbicacion !== null){
										fil = Number(this.tickets[m].ticketUbicacion.filaId);
										asi = Number(this.tickets[m].ticketUbicacion.asientoId);
									}

									let itemTicketCortesia = {
										TicketId: this.tickets[m].ticketNum,
										TicketTipo: '',
										TicketMonto: 0,
										TribunaId: Number(this.cortesia.CortesiaTribunaId),
										SectorCod: this.cortesia.CortesiaSectorCod,
										FilaId: fil,
										AsientoId: asi,
										PersonaNombre: this.tickets[m].ticketNombre.trim(),
										PersonaApellido: this.tickets[m].ticketApellido.trim(),
										PersonaDocumentoTipoId: Number(this.tickets[m].ticketDocumentoTipo),
										PersonaDocumentoTipoNombre: '',
										PersonaDocumentoTipoAbreviacion: '',
										PersonaDocumento: this.tickets[m].ticketDocumento,
										TransaccionId: ''
									}

									colTicketCortesias.push(itemTicketCortesia);

									this.tickets[m].Campos.forEach((campo) => {
										let value = null;
										let campoActual = this.eventoCampos.find((ec) => ec.CampoCod === campo.CampoCod)
										
										if(campoActual.CampoTipo === 'O'){
											if(campo.TicketCampoValor){
												value = Number(campo.TicketCampoValor.trim())
											}
										} else {
											if(campo.TicketCampoValor && campo.TicketCampoValor.trim() !== ''){
												value = campo.TicketCampoValor.trim()
											}
										}

										if(value){
											TicketCampoValor = {
												Index: Number(m + 1),
												CampoCod: campo.CampoCod,
												TicketCampoValor: value
											}

											SDTTicketCampoValores.push(TicketCampoValor)
										}
									});
								}
							} else {
								hayError = true
								this.$store.dispatch('showError', 'Debes ingresar todos los datos para el ticket #' + this.tickets[m].ticketNum)
							}
						}
					}

					SDTTicketCampoValoresJSON = JSON.stringify(SDTTicketCampoValores);

					if(hayError === false){
						this.$store.dispatch('cargando', true);

						try {
							let response = await axios.post('/WSCortesiaTicket', {
								EventoId: this.eventoId,
								CortesiaId: Number(this.$route.params.cortesiaId),
								CortesiaToken: this.$route.params.cortesiaToken,
								SDTTicketsCortesia: colTicketCortesias, 
								SDTTicketCampoValoresJSON: SDTTicketCampoValoresJSON
							});

							if(response.data.ErrorCod === 0){
								this.$store.dispatch('showSuccess', 'Cortesías emitidas correctamente')
								await this.validarCortesia();
								this.$store.dispatch('cargando', false);
							} else {
								if(response.data.ErrorCod === 1 || response.data.ErrorCod === 10 || response.data.ErrorCod === 20 || response.data.ErrorCod === 30 || response.data.ErrorCod === 40 || response.data.ErrorCod === 50 || response.data.ErrorCod === 60 || response.data.ErrorCod === 61 || response.data.ErrorCod === 80 || response.data.ErrorCod === 90){
									this.$store.dispatch('showError', 'Ocurrió un error')
									this.$router.push({ name: 'error' });
								} else {
									this.$store.dispatch('showError', response.data.ErrorDsc)
									this.$store.dispatch('cargando', false);
								}
							}
						} catch (error) {
							this.$store.dispatch('showError', 'Ocurrió un error, intenta nuevamente.')
							this.$store.dispatch('cargando', false);
						}
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	#cortesia-page{
		background-color: var(--color-white);
		@include flex(column, flex-start, flex-start);
		padding: 60px 0px;
		min-height: calc(100vh - 80px);

		.floating-button{
			display: none;
			width: 100%;
			
			button{
				@include flex(row, center, center);
				background-color: #222222;
				border: 1px solid #222222;
				border-radius: 8px;
				outline: none;
				padding: 13px 22px;
				color: var(--color-white);
				font-size: 14px;
				font-weight: var(--fw-600);
				font-family: var(--font-sora);
				line-height: 1.4em;
				letter-spacing: 1px;
				margin: 0px;
				@include transition(all 0.2s);
				cursor: pointer;

				&:hover {
					// background-color: var(--color-black);
					background-color: var(--color-primary);
					border: 1px solid #222222;
					color: #222222;
					transform: translate(-0.25rem, -0.25rem);
					box-shadow: 0.25rem 0.25rem 0 #222222;
				}

				&:disabled {
					background-color: #e8e9eb;
					color: var(--color-darker);
					border-color: #e8e9eb;
					cursor: not-allowed;

					&:hover {
						background-color: #e8e9eb;
						border: 1px solid #e8e9eb;
						color: var(--color-darker);
						transform: none;
						box-shadow: none;
					}
				}

				.emitiendo-loader{
					margin-left: 10px;
					margin-bottom: -3px;
				}
			}
		}

		.container{
			@include flex(row, space-between, flex-start);

			.cortesia-main{
				width: calc(100% - 440px);
				@include flex(column, flex-start, flex-start);
				padding-right: 40px;

				.cortesia-main-top{
					width: 100%;
					@include flex(row, space-between, center);

					.cortesia-main-top-left{
						@include flex(column, center, flex-start);

						.title{
							font-size: 18px;
							font-family: var(--font-sora);
							font-weight: var(--fw-700);
						}

						p{
							margin-top: 3px;
							font-size: 13px;
						}
					}
				}

				.cortesia-main-content{
					width: 100%;
					display: grid;
					grid-template-columns: repeat(2, 1fr);
					grid-auto-rows: 1fr;
					grid-column-gap: 20px;
					grid-row-gap: 20px;
					margin: 20px 0px 70px 0px;
					
					.ticket{
						width: 100%;
						padding-bottom: 20px;
						@include flex(column, flex-start, flex-start);
						border: 1px solid #222222;
						transform: translate(-0.25rem, -0.25rem);
						box-shadow: 0.25rem 0.25rem 0 #222222;
						border-radius: 8px;

						.ticket-top{
							width: 100%;
							padding: 0px;
							height: 60px;
							@include flex(row, flex-start, center);
							border-bottom: 1px solid #ccc;
							margin-bottom: 14px;

							.ticket-top-left{
								width: 60px;
								height: 60px;
								border-right: 1px solid #ccc;
								@include flex(column, center, center);
								position: relative;

								.ticket-text{
									font-size: 11px;
									line-height: 1em;
									margin-bottom: 4px;
									font-family: var(--font-sora);
									font-weight: var(--fw-400);
								}

								.ticket-id{
									font-weight: var(--fw-400);
									line-height: 1em;
									font-size: 18px;
								}
							}
							
							.ticket-top-right{
								padding-left: 14px;
								@include flex(column, center, flex-start);

								.sector{
									font-weight: var(--fw-700);
									font-family: var(--font-sora);
									font-size: 14px;
									line-height: 1em;
								}

								.sector-info{
									font-weight: var(--fw-400);
									font-family: var(--font-sora);
									font-size: 13px;
									line-height: 1em;
									margin-top: 7px;
								}

								.sector-calcular-aclarar{
									color: #9aa5b5;
									font-size: 12px;
								}
							}
						}

						.ticket-row-nominado, .ticket-row-campos{
							width: 100%;
							@include flex(column, flex-start, flex-start);
						}

						.ticket-row-nominado{
							border-top: 1px solid #ccc;
							margin-top: 14px;
							padding-top: 6px;
						}

						.ticket-row{
							width: 100%;
							padding: 0px 20px;
							@include flex(column, flex-start, flex-start);

							&.row-multiple{
								@include flex(row, space-between, center);

								.input-group{
									width: 50%;
								}
							}

							&.ticket-row-alerta-datos{
								.preseleccion-alerta{
									width: 100%;
									@include flex(row, flex-start, center);
									background-color: #e8e9eb;
									border: 1px solid #e8e9eb;
									border-radius: 8px;
									outline: none;
									padding: 7px 12px;
									margin: 10px 0px;
									@include transition(all 0.2s);
									cursor: pointer;

									i{
										font-size: 16px;
										margin-right: 10px;
									}

									span{
										font-size: 11px;
										color: var(--color-darker);
										font-weight: var(--fw-500);
										line-height: 1.45em;
									}
								}
							}

							.input-group{
								width: 100%;
								margin: 8px 0px 4px 0px;
								position: relative;
								@include flex(column, flex-start, flex-start);

								label {
									font-size: 13px;
									font-weight: var(--fw-600);
									margin-top: 0px;
									margin-bottom: 5px;
									line-height: 1em;
								}

								span{
									font-size: 14px;
									line-height: 1.4em;
									font-weight: var(--fw-400);
								}

								input {
									-webkit-appearance: none;
									appearance: none;
									border: none;
									width: 100%;
									padding: 0px 14px 0px 14px;
									font-size: 14px;
									font-weight: var(--fw-400);
									line-height: 1.4em;
									width: 100%;
									border-radius: 8px;
									height: 44px;
									outline: none;
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
									// box-shadow: 0 0 #0000,0 0 #0000, 0 1px 2px 0 rgba(0,0,0,.05);

									&::placeholder {
										color: #9aa5b5;
										opacity: 1;
									}

									&:-ms-input-placeholder {
										color: #9aa5b5;
									}

									&::-ms-input-placeholder {
										color: #9aa5b5;
									}

									&:focus-within {
										@include transition(all 0.2s);
										box-shadow: #222 0px 0px 0px 2px inset;

										&.form-input--error {
											box-shadow: var(--color-red-error) 0px 0px 0px 2px inset;
										}
									}

									&.form-input--error {
										box-shadow: var(--color-red-error) 0px 0px 0px 1px inset;
									}
								}

								select{
									@include sinApariencia();
									width: 100%;
									height: 44px;
									background-image: url('../assets/ChevronUpDown.svg');
									background-repeat: no-repeat;
									background-size: 18px;
									background-position: right 5px center;
									font-size: 14px;
									font-weight: var(--fw-400);
									line-height: 1.4em;
									outline: none;
									border: none;
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset;
									padding: 0 14px;
									border-radius: 8px;
									padding: 0px 36px 0px 14px;
									cursor: pointer;

									&:focus{
										box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset, 0 0 0px 1000px transparent inset;
									}
								}

								input:-webkit-autofill,
								input:-webkit-autofill:hover,
								input:-webkit-autofill:focus,
								textarea:-webkit-autofill,
								textarea:-webkit-autofill:hover,
								textarea:-webkit-autofill:focus,
								select:-webkit-autofill,
								select:-webkit-autofill:hover,
								select:-webkit-autofill:focus {
									border: none;
									-webkit-text-fill-color: var(--color-darker);
									box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px transparent inset;
									-webkit-box-shadow: rgb(176, 176, 176) 0px 0px 0px 1px inset, 0 0 0px 1000px transparent inset;

									&:focus-within {
										box-shadow: rgb(34, 34, 34) 0px 0px 0px 2px inset, 0 0 0px 1000px transparent inset;
									}
								}

								.input-group-aux{
									width: 100%;
									margin: 0px;
									position: relative;
									@include flex(row, flex-start, center);

									select{
										position: absolute;
										top: 50%;
										left: 2px;
										transform: translateY(-50%);
										@include sinApariencia();
										width: 44%;
										height: calc(100% - 4px);
										background-image: url('../assets/ChevronUpDown.svg');
										background-repeat: no-repeat;
										background-size: 18px;
										background-position: right 5px center;
										font-family: var(--font-inter);
										font-weight: var(--fw-500);
										font-size: 12px;
										border: none;
										padding: 0 14px;
										border-radius: 8px 0px 0px 8px;
										border-right: 1px solid #b0b0b0;
									}

									input{
										width: 100%;
										padding-left: calc(44% + 14px);
									}
								}
							}

							button.preseleccionar-button{
								@include flex(row, center, center);
								background-color: #e8e9eb;
								border: 1px solid #e8e9eb;
								border-radius: 8px;
								outline: none;
								padding: 7px 12px;
								color: var(--color-darker);
								font-size: 10px;
								font-weight: var(--fw-600);
								font-family: var(--font-sora);
								line-height: 1.2em;
								letter-spacing: 0.5px;
								text-transform: uppercase;
								margin: 10px 0px;
								@include transition(all 0.2s);
								cursor: pointer;

								&:hover {
									opacity: 0.9;
									border-color: var(--color-darker);
								}

								i{
									font-size: 16px;
									margin-right: 5px;
								}
							}
						}
					}

					.ticket-emitido{
						background: var(--color-white);
						border-radius: 12px;
						padding: 20px;
						border: 1px solid rgb(221, 221, 221);
						box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;
						@include flex(column, flex-start, flex-start);

						.ticket-id{
							font-size: 10px;
							color: #9aa5b5;
							font-weight: var(--fw-400);
							line-height: 1.4em;
							margin-bottom: 5px;
						}

						.ticket-row{
							width: 100%;
							@include flex(row, space-between, center);

							.field-group{
								width: 50%;
								margin: 7px 0px;
								@include flex(column, center, flex-start);

								&.field-group-100{
									width: 100%;
								}

								&.field-group-40{
									width: 40%;
								}

								&.field-group-60{
									width: 60%;
								}

								label{
									font-size: 12px;
									font-weight: var(--fw-600);
									letter-spacing: 0.3px;
									line-height: 1.4em;
								}

								.field{
									font-size: 13px;
									line-height: 1.4em;
								}
							}
						}

						.ticket-bottom{
							width: 100%;
							margin-top: 10px;
							@include flex(column, flex-end, flex-start);
							
							a{
								width: 100%;
								text-decoration: none;
								@include flex(row, center, center);
								background-color: #222222;
								border: 1px solid #222222;
								border-radius: 8px;
								outline: none;
								padding: 11px 16px;
								color: var(--color-white);
								font-size: 13px;
								font-weight: var(--fw-600);
								font-family: var(--font-sora);
								line-height: 1.4em;
								letter-spacing: 1px;
								margin: 0px;
								@include transition(all 0.2s);
								cursor: pointer;

								&:hover {
									background-color: var(--color-primary);
									border: 1px solid #222222;
									color: #222222;
									transform: translate(-0.25rem, -0.25rem);
									box-shadow: 0.25rem 0.25rem 0 #222222;
								}

								i{
									font-size: 16px;
									margin-right: 8px;
								}
							}

							.generando-loader{
								margin-left: 10px;
								margin-bottom: -3px;
							}

							.ticket-generando{
								width: 100%;
								text-decoration: none;
								@include flex(row, center, center);
								background-color: #f1f1f1;
								border: 1px solid #f1f1f1;
								border-radius: 8px;
								outline: none;
								padding: 11px 16px;
								color: var(--color-darker);
								font-size: 13px;
								font-weight: var(--fw-600);
								font-family: var(--font-sora);
								line-height: 1.4em;
								letter-spacing: 1px;
								margin: 0px;
							}

							.disclaimer-generando{
								margin-top: 8px;
								font-size: 11px;
								line-height: 1.4em;
								width: 100%;
							}
						}
					}
				}
			}

			aside{
				position: sticky;
				top: 100px;
				width: 440px;
				@include flex(column, flex-start, center);

				.aside-wrapper{
					@include flex(column, flex-start, flex-start);
					border-radius: 22px;
					box-shadow: rgba(0, 0, 0, 0.12) 0px 6px 16px;
					border: 1px solid rgba(0, 0, 0, 0.1);
					margin-bottom: 20px;

					.aside-top{
						width: 100%;
						border-radius: 22px 22px 0px 0px;
						@include flex(column, flex-start, flex-start);
						position: relative;
						padding: 30px 30px 76px 30px;
						background-color: var(--color-darker);
						background-position: center;
						background-size: cover;
						background-repeat: no-repeat;

						.evento-title{
							color: var(--color-white);
							font-family: var(--font-sora);
							font-weight: var(--fw-700);
							font-size: 22px;
							line-height: 1.4em;
							z-index: 2;
						}

						.aside-top-info{
							position: absolute;
							width: calc(100% - 60px);
							height: 112px;
							bottom: -56px;
							left: 30px;
							background-color: var(--color-white);
							// z-index: 99;
							border-radius: 12px;
							padding: 14px;
							box-shadow: rgba(0, 0, 0, 0.12) 0px 4px 22px;
							z-index: 10;
							@include flex(row, flex-start, center);

							.evento-foto{
								border-radius: 12px;
								height: 80px;
								width: 80px;
								object-fit: cover;
								margin-right: 20px;
							}

							.aside-top-info-right{
								@include flex(column, center, flex-start);

								.evento-info-categoria{
									font-weight: var(--fw-700);
									line-height: 1em;
									font-size: 12px;
								}

								.evento-info-fecha{
									font-weight: var(--fw-400);
									line-height: 1em;
									margin-top: 5px;
									font-size: 13px;
								}

								.evento-info-escenario{
									font-weight: var(--fw-400);
									line-height: 1em;
									margin-top: 5px;
									font-size: 13px;
								}
							}
						}

						&:before{
							content: '';
							position: absolute;
							background: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.3));
							top: 0;
							left: 0;
							width: 100%;
							height: 100%;
							z-index: 0;
							border-radius: 22px 22px 0px 0px;
						}
					}

					.aside-main{
						width: 100%;
						@include flex(column, flex-start, flex-start);
						padding: 80px 30px 30px 30px;
						position: relative;
						z-index: 4;

						.aside-row{
							width: 100%;
							@include flex(row, space-between, center);

							&.aside-row-item{
								margin: 1px 0px;
							}

							&.aside-row-concepto{
								margin: 5px 0px;
							}

							&.aside-row-concepto-total{
								margin: 8px 0px;
							}

							&.aside-row-terminos{
								width: 100%;
								margin-top: 15px;
								@include flex(column, flex-start, center);

								.terminos {
									font-size: 11px;
									text-align: center;
									width: 100%;
									padding-bottom: 15px;
									line-height: 1.5em;
									color: #9aa5b5;

									a {
										color: var(--color-darker);
										font-weight: var(--fw-600);
									}
								}
							}

							.divider{
								position: relative;
								width: 100%;
								height: 1px;
								border-top: 1px dashed rgba(0, 0, 0, 0.25);
								margin: 16px 0px;
							}

							.resumen-text{
								font-size: 17px;
								font-weight: var(--fw-300);
								margin-bottom: 16px;
								line-height: 1em;
							}

							.sector-text{
								font-size: 14px;
								font-weight: var(--fw-600);
								line-height: 1em;
								margin-bottom: 5px;
							}

							.sector-text-info{
								font-size: 13px;
								font-weight: var(--fw-300);
								margin-bottom: 5px;
							}

							.item, .item-monto{
								font-size: 13px;
								font-weight: var(--fw-400);
								line-height: 1.4em;
								margin-top: 3px;
							}

							.concepto-subtotal, .concepto-comision, .monto-subtotal, .monto-comision{
								font-family: var(--font-sora);
								font-size: 13px;
								font-weight: var(--fw-400);
								line-height: 1em;
							}

							.concepto-total, .monto-total{
								font-family: var(--font-sora);
								font-size: 18px;
								font-weight: var(--fw-600);
								line-height: 1em;
							}

							button{
								@include flex(row, center, center);
								width: 100%;
								background-color: #222222;
								border: 1px solid #222222;
								border-radius: 8px;
								outline: none;
								padding: 13px 22px;
								color: var(--color-white);
								font-size: 14px;
								font-weight: var(--fw-600);
								font-family: var(--font-sora);
								line-height: 1.4em;
								letter-spacing: 1px;
								margin: 8px 0px 0px 0px;
								@include transition(all 0.2s);
								cursor: pointer;

								&:hover {
									// background-color: var(--color-black);
									background-color: var(--color-primary);
									border: 1px solid #222222;
									color: #222222;
									transform: translate(-0.25rem, -0.25rem);
									box-shadow: 0.25rem 0.25rem 0 #222222;
								}

								&:disabled {
									background-color: #e8e9eb;
									color: var(--color-darker);
									border-color: #e8e9eb;
									cursor: not-allowed;

									&:hover {
										background-color: #e8e9eb;
										border: 1px solid #e8e9eb;
										color: var(--color-darker);
										transform: none;
										box-shadow: none;
									}
								}

								.emitiendo-loader{
									margin-left: 10px;
									margin-bottom: -3px;
								}
							}
						}

						.aside-bottom{
							width: 100%;
							@include flex(column, flex-start, flex-start);
							margin-top: 20px;

							.aside-bottom-row{
								width: 100%;
								@include flex(row, flex-start, flex-start);

								.check-icon{
									@include flex(row, center, center);
									margin-right: 14px;
									border-radius: 99px;
									background-color: #04ab70;
									width: 22px;
									height: 22px;

									i{
										color: var(--color-white);
										font-size: 18px;
									}
								}
								
								.aside-bottom-group{
									width: calc(100% - 36px);
									@include flex(column, center, flex-start);

									.aside-bottom-title{
										font-size: 13px;
										font-weight: var(--fw-700);
										font-family: var(--font-sora);
										margin-bottom: 8px;
										line-height: 1em;
										margin-top: 3px;
									}

									.aside-bottom-text{
										font-size: 11px;
										font-weight: var(--fw-400);
										// font-family: var(--font-sora);
										line-height: 1.3em;
									}
								}
							}
						}
					}
				}
			}

			.evento-loader{
				padding: 60px 40px 60px 0px;
				@include flex(row, center, center);
				width: 100%;
			}
		}
	}

	@media screen and (max-width: 1400px){
		#cortesia-page{
			.container{
				padding-left: 24px;
				padding-right: 24px;
			}
		}
	}

	@media screen and (max-width: 1300px){
		#cortesia-page{
			padding: 30px 0px;

			.container{
				.cortesia-main{
					width: calc(100% - 410px);
					padding-right: 20px;
				}
				
				aside{
					width: 410px;
				}
			}
		}
	}

	@media screen and (max-width: 1180px){
		#cortesia-page{
			.floating-button{
				position: fixed;
				@include flex(row, flex-end, center);
				width: 100%;
				bottom: 0;
				left: 0;
				background-color: var(--color-white);
				z-index: 999;
				padding: 12px 24px;
				box-shadow: rgba(0, 0, 0, 0.12) 0px -6px 16px;
				border: 1px solid rgba(0, 0, 0, 0.1);
			}

			.container{
				@include flex(column, flex-start, flex-start);

				.cortesia-main{
					width: 100%;
					padding-right: 0px;

					.cortesia-main-content{
						margin: 20px 0px 30px 0px;
					}
				}
				
				aside{
					width: 440px;
					margin: 0 auto;
				}
			}
		}
	}

	@media screen and (max-width: 866px){
		#cortesia-page{
			.container{
				.cortesia-main{
					.cortesia-main-top{
						.cortesia-main-top-left{
							padding-right: 20px;
						}
					}

					.cortesia-main-content{
						grid-template-columns: repeat(1, 1fr);
						margin: 20px auto 20px auto;
						max-width: 440px;

						.ticket, .ticket-emitido{
							max-width: 440px;
						}
					}
				}
				
				aside{
					width: 440px;
					margin: 0 auto;
				}
			}
		}
	}

	@media screen and (max-width: 460px){
		#cortesia-page{
			.container{
				.cortesia-main{
					.cortesia-main-content{
						.ticket{
							.ticket-row .input-group .input-group-aux select{
								width: 60%;
							}

							.ticket-row .input-group .input-group-aux input{
								padding-left: calc(60% + 14px);
							}
						}
					}
				}
			}
		}
	}

	@media screen and (max-width: 536px){
		#cortesia-page{
			.floating-button{
				button{
					width: 100%;
					font-size: 13px;
					padding: 11px 22px;
				}
			}
			.container{
				.cortesia-main{
					.cortesia-main-content{
						max-width: unset;

						.ticket{
							max-width: unset;
							width: 100%;
						}
					}
				}

				aside{
					width: 100%;
					margin: 0;

					.aside-wrapper{
						.aside-top{
							padding: 20px 20px 56px 20px;

							.evento-title{
								font-size: 18px;
							}

							.aside-top-info{
								height: 92px;
								bottom: -46px;
								width: calc(100% - 40px);
								left: 20px;
								padding: 12px;

								.evento-foto{
									width: 68px;
									height: 68px;
									border-radius: 8px;
									margin-right: 12px;
								}

								.aside-top-info-right{
									.evento-info-categoria{
										font-size: 11px;
									}

									.evento-info-fecha{
										font-size: 12px;
									}

									.evento-info-escenario{
										font-size: 12px;
									}
								}
							}
						}

						.aside-main{
							padding: 80px 20px 20px 20px;

							.aside-row{
								.resumen-text{
									font-size: 15px;
									margin-bottom: 12px;
								}

								.sector-text{
									font-size: 13px;
								}

								.sector-text-info{
									font-size: 12px;
								}

								.item{
									font-size: 12px;
									font-weight: var(--fw-500);
								}

								.item-monto{
									font-size: 12px;
									font-weight: var(--fw-500);
								}

								.divider{
									margin: 12px 0px;
								}

								.concepto-subtotal{
									font-size: 12px;
								}

								.monto-subtotal{
									font-size: 12px;
								}

								.concepto-comision{
									font-size: 12px;
								}

								.monto-comision{
									font-size: 12px;
								}

								.concepto-total{
									font-size: 15px;
								}

								.monto-total{
									font-size: 15px;
								}

								button{
									padding: 11px 20px;
									font-size: 13px;
								}
							}
						}
					}
				}
			}
		}
	}
</style>